module.exports = __webpack_public_path__ + "img/beer_id-27.7812d747.png";